module.exports = __webpack_public_path__ + "img/stock.c5da955.png";